module.exports = __webpack_public_path__ + "static/img/qualifications_icon_04.811e84c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/qualifications_icon_04.png
// module id = K8Go
// module chunks = 3